import React, { useEffect } from 'react';
import { useThemeStore } from '../../state/theme';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  width?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  width = '300px',
}) => {
  const { isDarkMode } = useThemeStore();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (document.activeElement === inputRef.current) {
        inputRef.current?.blur();
      } else {
        inputRef.current?.focus();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="relative" title="Press Enter to focus">
      <input
        ref={inputRef}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className={`px-4 py-2 pr-10 rounded-md text-sm focus:outline-none focus:ring-2 ${
          isDarkMode
            ? 'bg-gray-700 border-gray-600 text-gray-200 placeholder-gray-400 focus:ring-gray-500'
            : 'bg-white border border-gray-200 text-gray-900 focus:ring-blue-500'
        }`}
        style={{ width }}
      />
      {value ? (
        <button
          onClick={onClear}
          className={`absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600`}
        >
          <svg
            className={`w-4 h-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      ) : (
        <p
          style={{ fontSize: '0.5rem', padding: '2px 4px' }}
          className="absolute uppercase right-2 top-1/2 -translate-y-1/2 p-1 rounded-full text-gray-400 border border-gray-400 rounded-sm"
        >
          Enter
        </p>
      )}
    </div>
  );
};

export default SearchInput;
